import { useMemo } from "react";
import { Book } from "@/types/book";

// Lightweight hook that derives random books from already-loaded data
export function useRandomBooks(
  allBooks: Book[] | undefined,
  excludeBookId?: number,
  limit: number = 5
) {
  const randomBooks = useMemo(() => {
    if (!allBooks || allBooks.length === 0) return [];

    // Filter to only books with bundles, excluding the current book
    let filteredBooks = allBooks.filter(book => book.bundle_id !== null);
    if (excludeBookId) {
      filteredBooks = filteredBooks.filter(book => book.id !== excludeBookId);
    }

    // Shuffle and take limit
    const shuffled = [...filteredBooks].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, limit);
  }, [allBooks, excludeBookId, limit]);

  return {
    data: randomBooks,
    isLoading: !allBooks,
    isError: false,
    error: null
  };
}
